// Replacement for Next.js' built-in `@next/polyfill-module`, which is imported
// unconditionally by the App Router runtime and is NOT gated by browserslist.
// Wired up via Turbopack `resolveAlias` in `createCarmaNextConfig.ts`.
//
// Background / re-verify after Next.js upgrades:
//   - Issue:      https://github.com/vercel/next.js/issues/86785
//   - Discussion: https://github.com/vercel/next.js/discussions/64330
//   - Upstream fix (in progress): https://github.com/vercel/next.js/pull/88551
//   - Upstream source this mirrors: packages/next-polyfill-module/src/index.js
//
// The upstream module polyfills 8 features. Seven of them
// (String.prototype.trimStart/trimEnd, Symbol.prototype.description,
// Array.prototype.flat/flatMap, Promise.prototype.finally, Object.fromEntries,
// Array.prototype.at, Object.hasOwn) are already natively supported by Next's
// modern browser target (chrome 111 / edge 111 / firefox 111 / safari 16.4), so
// shipping them is pure dead weight and trips PageSpeed's "legacy JavaScript"
// audit.
//
// Only `URL.canParse` (baseline Chrome 120 / Firefox 115 / Safari 17) is not yet
// covered by the modern target, so we keep just that one here.
'canParse' in URL ||
  (URL.canParse = function (url, base) {
    try {
      return !!new URL(url, base);
    } catch {
      return false;
    }
  });
